(function ($) {

    $(document).ready(function () {

        let clicksCount = ( sessionStorage.getItem('showPopup') ) ?  sessionStorage.getItem('showPopup')  : 0 ;
        document.addEventListener('click', listenerClicks);

        function listenerClicks(e) {
            clicksCount++;
            sessionStorage.setItem('showPopup', clicksCount);
            if (sessionStorage.getItem('showPopup') == 5) {

                if(e.target.tagName == "A") {
                    var currentUrl = $(e.target).attr("href");

                    console.log(e.target.tagName);
                    e.preventDefault();
                }

                if(e.target.tagName == "IMG") {
                    console.log(e.target.tagName);
                    e.preventDefault();
                }
                
                $('.popup-email').addClass('show-popup');
                document.removeEventListener('click', listenerClicks);
                $('html').css('overflow', 'hidden');
            }

            $('.popup-email-close').on('click', function(){
                $('.popup-email').removeClass('show-popup');
                $('html').css('overflow', 'scroll');

                if(typeof currentUrl === 'undefined') {
                } else if(currentUrl === null){
                } else {
                    window.location.href = currentUrl;
                }
            })

            $('#mc-embedded-subscribe-form').on('submit', function(){
                if(typeof currentUrl === 'undefined') {
                } else if(currentUrl === null){
                } else {
                    window.location.href = currentUrl;
                }
            })
        }

        $('.popup-email-btn').on('click', function(){
            $('html').css('overflow', 'hidden');
            $('.wrap-embed-form').css('display', 'block');
            $('.popup-email-title').css('display', 'none');
            $('.popup-email-text').css('display', 'none');
            $('.popup-email-btn').css('display', 'none');
        })

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/popup-email.es6